import { makeStyles, Theme } from "@material-ui/core";
export const useStyles = makeStyles((theme: Theme) => ({
  selectField: {},
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  closeButton: {
    border: "0.5px solid #E08489",
    width: 100,
    height: 40,
    borderRadius: 5,
    "&:hover": {
      borderColor: "#c4122f",
    },
  },
  padding25: {
    paddingLeft: "2%",
    paddingRight: "2%",
  },
  dropDown: {
    width: "100%",
    padding: 0,
  },
  input: {
    padding: "1.5px 4px !important",
  },
  inputRoot: {
    height: "40px !important",
  },
  tableTitle: {
    fontSize: 18,
    marginBottom: 5,
  },
  addTitle: {
    fontSize: 15,
    marginTop: 10,
  },
  width800: {
    width: 1000,
  },
  marginTop15: {
    marginTop: 10,
  },
  padding5: {
    padding: 5,
  },
  maginLeft25: {
    marginLeft: 24,
    fontSize: 16,
    marginTop: 10,
  },
  selectPermission: {
    width: "100%",
  },
  deleteMessage: { fontFamily: "inherit", color: "inherit", fontSize: 18 },
  deleteMessage2: { fontFamily: "inherit", color: "inherit", fontSize: 16 },
  deleteName: { marginLeft: 5, fontWeight: "bold", fontSize: 18 },
  deleteName2: { marginLeft: 5, fontWeight: "bold", fontSize: 16 },
  permission: { width: "26%", fontSize: 16, marginTop: 10 },
  width20: { width: 20, marginTop: 10 },
  width260: { width: "11.2rem", display: "flex", alignItems: "center" },
  width12: { width: "12.2rem", display: "flex", alignItems: "center" },
}));
